import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getKpiConfig } from '../../common/service/dataOperations';
import { resolveKpiConfig, KpiDashboardConfig, RemoteKpiConfig } from './kpiConfig';

// Prefetched in NavProvider on client load — this just reads the warm cache. Shared by
// useDashboardKPIData (the project dashboard) and any other consumer that needs a kpiConfig
// field (e.g. excludedPackageKeywords, modules.compliance) without the full 15-log fetch.
export function useKpiConfig(
  clientAPIURL: string,
  accessToken: string | null,
  projectId: string | null,
): KpiDashboardConfig {
  const { data: remoteKpiConfig } = useQuery<RemoteKpiConfig | null>({
    queryKey: ['kpiConfig'],
    queryFn: (): Promise<RemoteKpiConfig | null> => getKpiConfig(clientAPIURL, accessToken),
    enabled: !!accessToken && !!clientAPIURL,
    staleTime: 30 * 60 * 1000,
  });
  return useMemo(() => resolveKpiConfig(remoteKpiConfig, projectId), [remoteKpiConfig, projectId]);
}
